export default __webpack_public_path__ + "static/media/Candidate.c84fd496.png";